import 'core-js/modules/es.array.push.js';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { useState, useEffect } from 'react';
import _jsx from '@babel/runtime/helpers/jsx';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'prop-types';
import classNames from 'classnames';
import { namespaceRecommendations as namespaceRecommendations$1 } from '@recommendations-fe/commons/namespaces';
import MoneyAmount, { MoneyAmount as MoneyAmount$1 } from '@andes/money-amount';
import { priceSizeByDigits, interpolator as interpolator$1, recommendationsService } from '@recommendations-fe/commons';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/es.regexp.exec.js';
import isEmpty from 'lodash/isEmpty';
import isObject from 'lodash/isObject';
import 'core-js/modules/es.array.includes.js';
import 'core-js/modules/es.array.reduce.js';
import 'core-js/modules/es.string.replace.js';
import NordicImage from 'nordic/image';
const mapDecimalSymbol$1 = {
  ',': 'comma',
  '.': 'dot'
};
const defaultMiddleText = 'x ';
const Installments = _ref => {
  let {
    namespace: namespaceFromProps,
    installments,
    svg,
    fontSizeOverride
  } = _ref;
  const namespace = "".concat(namespaceFromProps, "__installments");
  const hasNewVariants = installments.middle_text;
  return /*#__PURE__*/jsx(Fragment, {
    children: installments.alternative_text ? /*#__PURE__*/_jsx("span", {
      className: "".concat(namespace, "-alternative-text")
    }, void 0, installments.alternative_text) : installments.quantity && installments.symbol && installments.fraction && /*#__PURE__*/_jsx("div", {
      className: classNames(namespace, {
        ["".concat(namespace, "--webView")]: svg
      }, {
        ["".concat(namespace, "--free-webView")]: svg && installments.freeInstallments
      })
    }, void 0, /*#__PURE__*/_jsx("span", {
      className: svg ? "".concat(namespace, "--price text-installments-webView") : "".concat(namespace)
    }, void 0, installments.original_price && /*#__PURE__*/_jsx("span", {
      className: "".concat(namespace, "-original-price")
    }, void 0, installments.original_price.symbol ? /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(MoneyAmount, {
        value: {
          fraction: installments.original_price.fraction,
          cents: installments.original_price.cents
        },
        symbol: installments.original_price.symbol,
        currencyId: installments.original_price.currency_id,
        centsType: mapDecimalSymbol$1[installments.decimal_separator],
        size: fontSizeOverride || 14,
        compact: true
      }), ' ', installments.original_price.text]
    }) : installments.original_price.text), /*#__PURE__*/_jsx("span", {
      className: installments.freeInstallments ? "".concat(namespace, "-price--free") : "".concat(namespace, "-price")
    }, void 0, installments.before_text && hasNewVariants && /*#__PURE__*/_jsx("span", {
      className: "".concat(namespace, "-before-text")
    }, void 0, installments.before_text), /*#__PURE__*/_jsx("span", {
      className: "".concat(namespace, "-quantity")
    }, void 0, installments.quantity), /*#__PURE__*/_jsx("span", {
      className: "".concat(namespace, "-middle-text")
    }, void 0, hasNewVariants ? installments.middle_text : defaultMiddleText), /*#__PURE__*/_jsx(MoneyAmount, {
      value: {
        fraction: installments.fraction,
        cents: installments.cents
      },
      symbol: installments.symbol,
      currencyId: installments.currency_id,
      centsType: mapDecimalSymbol$1[installments.decimal_separator],
      size: fontSizeOverride || 14,
      compact: true
    }), "\xA0", installments.text && !hasNewVariants && /*#__PURE__*/_jsx("span", {
      className: "".concat(namespace, "-text")
    }, void 0, installments.text), installments.after_text && hasNewVariants && /*#__PURE__*/_jsx("span", {
      className: "".concat(namespace, "-after-text")
    }, void 0, installments.after_text))))
  });
};
const namespaceRecommendations = 'ui-recommendations';
const generatorClassKey = (type, obj, className) => {
  const DEFAULT = false;
  const namespace = "".concat(namespaceRecommendations, "-").concat(type);
  // eslint-disable-next-line security/detect-object-injection
  const typeName = typeof obj === 'string' ? obj : obj && obj[type] || DEFAULT;
  return classNames({
    ["".concat(namespace, "--").concat(typeName)]: typeName
  }, className);
};

// eslint-disable-next-line camelcase
const applyClasses = _ref => {
  let {
    size,
    family,
    color,
    bg_color,
    className
  } = _ref;
  return (
    // eslint-disable-next-line implicit-arrow-linebreak
    generatorClassKey('background-color', bg_color, generatorClassKey('font-color', color, generatorClassKey('font-size', size, generatorClassKey('font-family', family, className))))
  );
};
const _excluded$3 = ["as", "withDangerous", "text", "color", "bg_color", "font_family", "font_size", "className", "accessibilityText", "children"];
function ownKeys$a(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$a(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$a(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$a(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
const createMarkup = text => ({
  __html: text
});
const allowedForwardedProps = ['href', 'target', 'id', 'onClick', 'data-testid'];
const filterForwardProps = function () {
  let forwardProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.entries(forwardProps).reduce((acc, _ref) => {
    let [name, value] = _ref;
    if (allowedForwardedProps.includes(name)) {
      // eslint-disable-next-line security/detect-object-injection
      acc[name] = value;
    }
    return acc;
  }, {});
};

// Map from BE props to FE naming
const StyledLabel = _ref2 => {
  let {
      as,
      withDangerous,
      text,
      color,
      // eslint-disable-next-line camelcase
      bg_color,
      // eslint-disable-next-line camelcase
      font_family,
      // eslint-disable-next-line camelcase
      font_size,
      className,
      accessibilityText,
      children
    } = _ref2,
    forwardProps = _objectWithoutProperties(_ref2, _excluded$3);
  const classes = applyClasses({
    // eslint-disable-next-line camelcase
    size: font_size,
    // eslint-disable-next-line camelcase
    family: font_family,
    color,
    // eslint-disable-next-line camelcase
    bg_color,
    className
  });
  const Element = as;
  const filteredForwardedProps = filterForwardProps(forwardProps);
  if (withDangerous) {
    return /*#__PURE__*/jsx(Element, _objectSpread$a(_objectSpread$a({
      className: classes
    }, filteredForwardedProps), {}, {
      dangerouslySetInnerHTML: createMarkup(text)
    }));
  }
  return /*#__PURE__*/jsxs(Element, _objectSpread$a(_objectSpread$a({
    className: classes
  }, filteredForwardedProps), {}, {
    children: [text, accessibilityText && /*#__PURE__*/_jsx("span", {
      className: "ui-home--hide"
    }, void 0, accessibilityText), children]
  }));
};
StyledLabel.defaultProps = {
  as: 'p',
  alignment: null,
  withDangerous: false,
  bg_color: null,
  className: null,
  text: null,
  color: null,
  font_family: 'REGULAR',
  font_size: null,
  accessibilityText: null,
  children: null,
  margin: null
};
function ownKeys$9(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$9(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$9(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$9(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
const INTERPOLATION_REGEXP = /{([\s\S]+?)}/g;
const RECOMMENDATIONS_REGEXP = /^recommendations-/i;
const prefixer = icon => {
  let replacement;
  if (typeof icon === 'string') {
    replacement = RECOMMENDATIONS_REGEXP.test(icon) ? icon : "recommendations-".concat(icon);
  }
  if (isObject(icon) && typeof icon.id === 'string') {
    replacement = _objectSpread$9(_objectSpread$9({}, icon), {}, {
      id: RECOMMENDATIONS_REGEXP.test(icon.id) ? icon.id : "recommendations-".concat(icon.id)
    });
  }
  return replacement;
};
const interpolator = (text, values, IconFactory) => {
  if (isEmpty(values)) {
    return text;
  }
  const result = text.split(INTERPOLATION_REGEXP);

  /* eslint-disable security/detect-object-injection */
  for (let index = 0; index < result.length; index += 1) {
    const key = result[index];
    if (values && values[key]) {
      const value = values[key];
      switch (value.type) {
        /* istanbul ignore next */
        case 'money':
          {
            const {
              amount,
              centsType,
              size
            } = value.price;
            const moneyAmountProps = {
              className: "".concat(namespaceRecommendations, "-card__price"),
              value: {
                fraction: amount.fraction.toString(),
                cents: amount.cents
              },
              symbol: amount.symbol,
              currencyId: amount.currency_id,
              size,
              centsType
            };
            result[index] = /*#__PURE__*/jsx(MoneyAmount, _objectSpread$9({}, moneyAmountProps));
          }
          break;
        case 'icon':
          {
            const prefixedIcon = prefixer(value);
            result[index] = IconFactory(prefixedIcon, "".concat(namespaceRecommendations, "-icon ").concat(namespaceRecommendations, "-icon-").concat(key));
          }
          break;
        default:
          result[index] = /*#__PURE__*/jsx(StyledLabel, _objectSpread$9({
            as: "span",
            text: text
          }, value));
          break;
      }
    }
  }
  return result;
};
function ownKeys$8(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$8(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$8(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$8(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
const defaultFontSize = 16;
const addFontSizeToValues = (values, fontSize) => {
  var _updatedValues$money;
  const updatedValues = _objectSpread$8({}, values);
  if (updatedValues !== null && updatedValues !== void 0 && (_updatedValues$money = updatedValues.money) !== null && _updatedValues$money !== void 0 && _updatedValues$money.price && typeof fontSize === 'number') {
    updatedValues.money.price.size = fontSize;
  }
  return updatedValues;
};
const InstallmentsOptions = _ref => {
  let {
    namespace: namespaceFromProps,
    options,
    className,
    priceSizeOverride
  } = _ref;
  if (!options || options.length === 0) return null;
  const namespace = "".concat(namespaceFromProps, "__installments_options");
  return /*#__PURE__*/_jsx("div", {
    className: classNames(namespace, className)
  }, void 0, options.map(option => {
    const {
      text,
      values
    } = option !== null && option !== void 0 ? option : {};
    if (!text) return null;
    const fontSize = priceSizeOverride || defaultFontSize;
    const computedValues = addFontSizeToValues(values, fontSize);
    return /*#__PURE__*/_jsx("div", {
      className: "".concat(namespace, "-option")
    }, text, interpolator(text, computedValues));
  }));
};
const RECOMMENDATIONS_HEART_EMPTY = 'recommendations-heart-empty';
const RECOMMENDATIONS_HEART_FULL = 'recommendations-heart-full';
const RECOMMENDATIONS_FULL_ICON = 'recommendations-full_icon';
const RECOMMENDATIONS_MELI_LOGO = 'recommendations-meli_logo';
const RECOMMENDATIONS_BLACK_FRIDAY_ICON = 'recommendations-black-friday_icon';
const RECOMMENDATIONS_MELICHOICE_LOGO = 'recommendations-melichoice_logo';
const AttributesPill = _ref => {
  var _pill$icon;
  let {
    namespace: namespaceFromProps,
    attributes_pill: pill,
    IconFactory
  } = _ref;
  const namespace = "".concat(namespaceFromProps, "__attributes-pill");
  const iconMap = {
    melichoice_logo: RECOMMENDATIONS_MELICHOICE_LOGO
  };
  return /*#__PURE__*/jsx(Fragment, {
    children: (pill === null || pill === void 0 ? void 0 : pill.text) && /*#__PURE__*/_jsx("div", {
      className: namespace
    }, void 0, /*#__PURE__*/_jsx("span", {
      className: classNames("".concat(namespace, "-label"), {
        ["".concat(namespace, "-label--success")]: pill.highlight,
        ["".concat(namespace, "-label--neutral")]: !pill.highlight
      })
    }, void 0, (pill === null || pill === void 0 ? void 0 : pill.icon) && IconFactory(iconMap[(_pill$icon = pill.icon) === null || _pill$icon === void 0 ? void 0 : _pill$icon.id], "".concat(namespace, "-icon")), pill.text))
  });
};
const mapDecimalSymbol = {
  ',': 'comma',
  '.': 'dot'
};
const PriceBlock = _ref => {
  let {
    namespace: namespaceFromProps,
    meta,
    price,
    priceSizeOverride,
    discount,
    attributes_pill,
    installments,
    installments_options,
    IconFactory
  } = _ref;
  const namespace = "".concat(namespaceFromProps, "__price");
  const {
    priceSize,
    discountSize
  } = priceSizeByDigits(price, priceSizeOverride);
  return /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace, "-block")
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace, "-top")
  }, void 0, (discount === null || discount === void 0 ? void 0 : discount.original_price) && /*#__PURE__*/_jsx(MoneyAmount$1, {
    value: {
      fraction: discount.original_price.fraction,
      cents: discount.original_price.cents
    },
    symbol: discount.original_price.symbol,
    currencyId: discount.original_price.currency_id,
    centsType: mapDecimalSymbol[discount.original_price.decimal_separator],
    className: "".concat(namespace, "-original-price"),
    size: (priceSizeOverride === null || priceSizeOverride === void 0 ? void 0 : priceSizeOverride.original) || 12,
    previous: true,
    compact: true
  }), /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace, "-and-discount")
  }, void 0, price.text && /*#__PURE__*/_jsx("span", {
    className: "".concat(namespace, "-text")
  }, void 0, price.text), price.currency_id && !price.text && /*#__PURE__*/_jsx(MoneyAmount$1, {
    value: {
      fraction: price.fraction,
      cents: price.cents
    },
    symbol: price.symbol,
    currencyId: price.currency_id,
    centsType: "superscript",
    className: namespace,
    size: priceSize,
    compact: true,
    meta: meta,
    suffix: price.suffix
  }), discount && /*#__PURE__*/_jsx("span", {
    className: "".concat(namespace, "-discount-text andes-money-amount__discount"),
    style: {
      fontSize: discountSize
    }
  }, void 0, discount.text))), attributes_pill && /*#__PURE__*/_jsx(AttributesPill, {
    namespace: namespaceFromProps,
    attributes_pill: attributes_pill,
    IconFactory: IconFactory
  }), installments && /*#__PURE__*/_jsx(Installments, {
    installments: installments,
    fontSizeOverride: priceSizeOverride === null || priceSizeOverride === void 0 ? void 0 : priceSizeOverride.installments,
    namespace: namespaceFromProps
  }), installments_options && /*#__PURE__*/_jsx(InstallmentsOptions, {
    namespace: namespaceFromProps,
    options: installments_options.options,
    priceSizeOverride: priceSizeOverride === null || priceSizeOverride === void 0 ? void 0 : priceSizeOverride.original
  }));
};
PriceBlock.defaultProps = {
  discount: null,
  installments: null,
  installments_options: null,
  attributes_pill: null,
  meta: null,
  priceSizeOverride: null,
  IconFactory: null
};
const MeliCoin = _ref => {
  let {
    namespace: namespaceFromProps,
    melicoin,
    IconFactory
  } = _ref;
  const namespace = "".concat(namespaceFromProps, "__melicoin");
  return melicoin && /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace)
  }, void 0, /*#__PURE__*/_jsx("span", {
    className: "".concat(namespace, "-text")
  }, "melicoin", interpolator$1(melicoin.label, melicoin.values, IconFactory)));
};
const Rebates = _ref => {
  let {
    namespace: namespaceFromProps,
    rebates
  } = _ref;
  const namespace = "".concat(namespaceFromProps, "__rebates");
  return /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace, "-block")
  }, void 0, Array.isArray(rebates) && rebates.map(rebate => /*#__PURE__*/_jsx("div", {
    className: namespace
  }, rebate.discount.text, rebate.discount && /*#__PURE__*/_jsx("span", {
    className: "".concat(namespace, "-tag")
  }, void 0, rebate.discount.text), rebate.remaining && !!rebate.remaining.text && /*#__PURE__*/_jsx("span", {
    className: "".concat(namespace, "-remaining ").concat(namespace, "-remaining--").concat(rebate.remaining.color.toLowerCase())
  }, void 0, rebate.remaining.text))));
};
const BenefitsBlock = _ref => {
  let {
    namespace: namespaceFromProps,
    melicoin,
    rebates,
    IconFactory,
    hideRebates
  } = _ref;
  const namespace = "".concat(namespaceFromProps, "__benefits");
  return /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace, "-block")
  }, void 0, melicoin && /*#__PURE__*/_jsx(MeliCoin, {
    melicoin: melicoin,
    namespace: namespaceFromProps,
    IconFactory: IconFactory
  }), !hideRebates && (rebates === null || rebates === void 0 ? void 0 : rebates.length) > 0 && /*#__PURE__*/_jsx(Rebates, {
    rebates: rebates,
    namespace: namespaceFromProps
  }));
};
const Shipping = _ref => {
  let {
    namespace: namespaceFromProps,
    shipping,
    IconFactory
  } = _ref;
  const namespace = "".concat(namespaceFromProps, "__shipping");
  return /*#__PURE__*/_jsx("span", {
    className: namespace
  }, void 0, shipping.text && /*#__PURE__*/_jsx("span", {
    className: "".concat(namespace, "-text")
  }, void 0, shipping.text, shipping.subText && /*#__PURE__*/_jsx("span", {
    className: "".concat(namespace, "-subtext")
  }, void 0, "\xA0", shipping.subText)), shipping.promise && /*#__PURE__*/_jsx("div", {}, void 0, /*#__PURE__*/_jsx("span", {
    className: classNames("".concat(namespace, "-promise"), {
      ["".concat(namespace, "-promise--dark")]: shipping.promise.highlight,
      ["".concat(namespace, "-promise--light")]: !shipping.promise.highlight
    })
  }, void 0, shipping.promise.text), shipping.fullfilment && IconFactory(RECOMMENDATIONS_FULL_ICON, "".concat(namespace, "-icon"))), shipping.fullfilment && !shipping.promise && IconFactory(RECOMMENDATIONS_FULL_ICON, "".concat(namespace, "-icon")));
};
Shipping.defaultProps = {
  shipping: null
};
const ChunkConditions = _ref => {
  let {
    namespace,
    meta,
    price,
    priceSizeOverride,
    discount,
    attributes_pill,
    installments,
    installments_options,
    melicoin,
    rebates,
    shipping,
    IconFactory,
    hideRebates
  } = _ref;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [(price || discount || attributes_pill || installments || installments_options) && /*#__PURE__*/_jsx(PriceBlock, {
      namespace: namespace,
      meta: meta,
      price: price,
      priceSizeOverride: priceSizeOverride,
      discount: discount,
      installments: installments,
      installments_options: installments_options,
      attributes_pill: attributes_pill,
      IconFactory: IconFactory
    }, "price"), (melicoin || !hideRebates && (rebates === null || rebates === void 0 ? void 0 : rebates.length) > 0) && /*#__PURE__*/_jsx(BenefitsBlock, {
      namespace: namespace,
      melicoin: melicoin,
      rebates: rebates,
      IconFactory: IconFactory,
      hideRebates: hideRebates
    }), shipping && /*#__PURE__*/_jsx(Shipping, {
      namespace: namespace,
      shipping: shipping,
      IconFactory: IconFactory
    }, "shipping")]
  });
};
const Attributes = _ref => {
  let {
    namespace: namespaceFromProps,
    attributes
  } = _ref;
  const namespace = "".concat(namespaceFromProps, "__attributes");
  return /*#__PURE__*/jsx(Fragment, {
    children: attributes && /*#__PURE__*/_jsx("span", {
      className: namespace
    }, "attributes", attributes.replace('<br/>', '\n'))
  });
};
const OnlineBooking = _ref => {
  let {
    namespace: namespaceFromProps,
    ltr_info: {
      title,
      subtitle
    }
  } = _ref;
  const namespace = "".concat(namespaceFromProps, "__online-booking");
  return /*#__PURE__*/jsx(Fragment, {
    children: (title || subtitle) && /*#__PURE__*/_jsx("div", {
      className: namespace
    }, void 0, title && /*#__PURE__*/_jsx("p", {
      className: "".concat(namespace, "-title")
    }, void 0, title), subtitle && /*#__PURE__*/_jsx("p", {
      className: "".concat(namespace, "-subtitle")
    }, void 0, subtitle))
  });
};
const ChunkAttributes = _ref => {
  let {
    namespace,
    attributes,
    ltr_info
  } = _ref;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [attributes && /*#__PURE__*/_jsx(Attributes, {
      namespace: namespace,
      attributes: attributes
    }), ltr_info && /*#__PURE__*/_jsx(OnlineBooking, {
      namespace: namespace,
      ltr_info: ltr_info
    })]
  });
};
const VerticalHighlightIcon = _ref => {
  let {
    namespace: namespaceFromProps,
    vertical,
    IconFactory
  } = _ref;
  const {
    icon: {
      id
    }
  } = vertical;
  const namespace = "".concat(namespaceFromProps, "__vertical-highlight");
  return /*#__PURE__*/_jsx("span", {
    className: namespace
  }, void 0, IconFactory(id, "".concat(namespace, "-icon")));
};
VerticalHighlightIcon.defaultProps = {
  vertical: null
};
const ValueProposition = _ref => {
  var _value_propositions$p;
  let {
    namespace: namespaceFromProps,
    value_propositions
  } = _ref;
  const namespace = "".concat(namespaceFromProps, "__value-proposition");
  return /*#__PURE__*/jsx(Fragment, {
    children: (value_propositions === null || value_propositions === void 0 || (_value_propositions$p = value_propositions.pills) === null || _value_propositions$p === void 0 ? void 0 : _value_propositions$p.length) > 0 && /*#__PURE__*/_jsx("span", {
      className: namespace
    }, void 0, value_propositions.pills.map(pill => /*#__PURE__*/_jsx("p", {
      className: "".concat(namespace, "-label")
    }, pill.label.text, pill.label.text)))
  });
};
ValueProposition.defaultProps = {
  value_propositions: null
};
const LastBuy = _ref => {
  let {
    namespace: namespaceFromProps,
    last_buy: lastBuy
  } = _ref;
  const namespace = "".concat(namespaceFromProps, "__last-buy");
  return /*#__PURE__*/jsx(Fragment, {
    children: /*#__PURE__*/_jsx("span", {
      className: namespace
    }, "last-buy", lastBuy)
  });
};
const ChunkOthers = _ref => {
  let {
    namespace,
    vertical_highlight,
    value_propositions,
    info_extra_landing,
    IconFactory
  } = _ref;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [vertical_highlight && /*#__PURE__*/_jsx(VerticalHighlightIcon, {
      namespace: namespace,
      vertical: vertical_highlight,
      IconFactory: IconFactory
    }), value_propositions && /*#__PURE__*/_jsx(ValueProposition, {
      namespace: namespace,
      value_propositions: value_propositions
    }), (info_extra_landing === null || info_extra_landing === void 0 ? void 0 : info_extra_landing.last_buy) && /*#__PURE__*/_jsx(LastBuy, {
      namespace: namespace,
      last_buy: info_extra_landing.last_buy
    })]
  });
};
const goToBrand = url => window.location = url;
const Brand = _ref => {
  let {
    brand,
    namespace: namespaceFromProps
  } = _ref;
  const namespace = "".concat(namespaceFromProps, "__brand");
  return /*#__PURE__*/jsx(Fragment, {
    children: (brand === null || brand === void 0 ? void 0 : brand.text) && (brand === null || brand === void 0 ? void 0 : brand.url) && /*#__PURE__*/_jsx("button", {
      className: "".concat(namespace),
      onClick: e => {
        e.preventDefault();
        goToBrand(brand.url);
      }
    }, "brand", brand.text)
  });
};
const AddToCartAction = _ref => {
  let {
    namespace: namespaceFromProps,
    id,
    label,
    addToCartPublicEndpoint,
    csrfToken
  } = _ref;
  const namespace = "".concat(namespaceFromProps, "__action");
  const itemInfo = {
    item_id: id,
    site_id: id.substring(0, 3),
    context: 'recommendations',
    quantity: 1
  };
  const ENDPOINT = addToCartPublicEndpoint;
  /* istanbul ignore next */
  const handleSubmit = e => {
    e.preventDefault();
    recommendationsService.addToCart(ENDPOINT, itemInfo).then(response => {
      window.location = response.data.url;
    }).catch(() => {});
  };
  return /*#__PURE__*/_jsx("form", {
    onSubmit: handleSubmit,
    action: "".concat(addToCartPublicEndpoint, "-redirect"),
    method: "POST",
    className: "".concat(namespace, "-form")
  }, void 0, /*#__PURE__*/_jsx("input", {
    type: "hidden",
    name: "_csrf",
    value: csrfToken
  }), /*#__PURE__*/_jsx("input", {
    type: "hidden",
    name: "item_id",
    value: itemInfo.item_id
  }), /*#__PURE__*/_jsx("input", {
    type: "hidden",
    name: "site_id",
    value: itemInfo.site_id
  }), /*#__PURE__*/_jsx("input", {
    type: "hidden",
    name: "context",
    value: itemInfo.context
  }), /*#__PURE__*/_jsx("input", {
    type: "hidden",
    name: "quantity",
    value: itemInfo.quantity
  }), /*#__PURE__*/_jsx("button", {
    className: namespace
  }, void 0, /*#__PURE__*/_jsx("span", {
    className: "".concat(namespace, "-label")
  }, void 0, label)));
};
AddToCartAction.defaultProps = {
  csrfToken: null
};
const Actions = _ref => {
  let {
    namespace,
    id,
    actions,
    csrfToken,
    addToCartPublicEndpoint
  } = _ref;
  return /*#__PURE__*/jsx(Fragment, {
    children: actions && actions.length !== 0 && actions.map(action => /*#__PURE__*/_jsx(AddToCartAction, {
      id: id,
      namespace: namespace,
      label: action.label,
      csrfToken: csrfToken,
      addToCartPublicEndpoint: addToCartPublicEndpoint
    }, action.id))
  });
};
function ownKeys$7(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$7(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$7(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$7(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
const ChunkHidden = _ref => {
  let {
    namespace,
    id,
    brand,
    actions,
    addToCartPublicEndpoint,
    csrfToken
  } = _ref;
  const actionsProps = {
    namespace,
    id,
    actions,
    addToCartPublicEndpoint,
    csrfToken
  };
  const hasActionsOrBrand = (actions === null || actions === void 0 ? void 0 : actions.length) > 0 || (brand === null || brand === void 0 ? void 0 : brand.url);
  return /*#__PURE__*/_jsx("div", {
    className: classNames("".concat(namespace, "__hidden"), {
      ["".concat(namespace, "__hidden--with-actions-or-brand")]: hasActionsOrBrand
    })
  }, "hidden", brand && /*#__PURE__*/_jsx(Brand, {
    namespace: namespace,
    brand: brand
  }), actions && /*#__PURE__*/jsx(Actions, _objectSpread$7({}, actionsProps)));
};
const _excluded$2 = ["bookmarkedItems", "onBookmarkClick", "bookmarkText", "namespace", "IconFactory"];
function ownKeys$6(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$6(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$6(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$6(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
const BookmarkButton = _ref => {
  let {
      bookmarkedItems = [],
      onBookmarkClick: onBookmarkClickFromProps,
      bookmarkText = 'Favorito',
      namespace: namespaceFromProps,
      IconFactory
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded$2);
  const namespace = "".concat(namespaceFromProps, "__bookmark-button");
  const [isBookmarked, setIsBookmarked] = useState(bookmarkedItems.some(bookmarkedItem => bookmarkedItem === rest.id));
  const [isFetchingBookmark, setIsFetchingBookmark] = useState(false);
  const onBookmarkClick = e => {
    e.preventDefault();
    e.stopPropagation();
    if (isFetchingBookmark) return;
    setIsFetchingBookmark(true);
    onBookmarkClickFromProps({
      isBookmarked,
      setIsBookmarked,
      setIsFetchingBookmark,
      itemProps: _objectSpread$6({}, rest)
    });
  };
  useEffect(() => {
    setIsBookmarked(bookmarkedItems.some(bookmarkedItem => bookmarkedItem === rest.id));
  }, [bookmarkedItems, rest.id]);
  const hearthEmpty = IconFactory(RECOMMENDATIONS_HEART_EMPTY, classNames("".concat(namespace, "-icon"), "".concat(namespace, "-icon-empty"), {
    ["".concat(namespace, "-icon-empty--active")]: isBookmarked
  }));
  const hearthFull = IconFactory(RECOMMENDATIONS_HEART_FULL, classNames("".concat(namespace, "-icon"), "".concat(namespace, "-icon-full"), {
    ["".concat(namespace, "-icon-full--active")]: isBookmarked
  }));
  return /*#__PURE__*/jsx(Fragment, {
    children: onBookmarkClickFromProps && /*#__PURE__*/_jsx("button", {
      "data-testid": "onclick-bookmark-button",
      className: classNames(namespace, {
        ["".concat(namespace, "--bookmarked")]: isBookmarked
      }),
      onClick: onBookmarkClick,
      role: "switch",
      "aria-checked": isBookmarked || false
    }, void 0, /*#__PURE__*/_jsx("span", {
      className: "andes-visually-hidden"
    }, void 0, bookmarkText), hearthFull, hearthEmpty)
  });
};
const iconMap = {
  meli_icon: RECOMMENDATIONS_MELI_LOGO,
  black_friday_icon: RECOMMENDATIONS_BLACK_FRIDAY_ICON
};
const renderPillStyles = (_ref, defaultStyles) => {
  let {
    label
  } = _ref;
  if (!label) return {};
  const {
    size,
    weight,
    style,
    color,
    background
  } = label;
  return {
    fontSize: size ? "".concat(size, "px") : defaultStyles.fontSize,
    fontWeight: weight ? "".concat(weight) : defaultStyles.fontWeight,
    fontStyle: style || defaultStyles.fontStyle,
    color: color || defaultStyles.color,
    background: background || defaultStyles.background
  };
};
const CustomPill = _ref2 => {
  var _pill$label;
  let {
    namespace: namespaceFromProps,
    pill,
    IconFactory,
    defaultStyles
  } = _ref2;
  const namespace = "".concat(namespaceFromProps, "__pill");
  return /*#__PURE__*/_jsx("span", {
    className: "".concat(namespace),
    style: renderPillStyles(pill, defaultStyles)
  }, void 0, pill.icon && IconFactory(iconMap[pill.icon.id], "".concat(namespace, "-icon")), (_pill$label = pill.label) === null || _pill$label === void 0 ? void 0 : _pill$label.text);
};
CustomPill.defaultProps = {
  pill: {
    icon: null,
    label: {}
  }
};
const defaultStyles$1 = {
  fontSize: '9px',
  fontWeight: '600',
  fontStyle: 'normal',
  color: '#FFFFFF',
  background: '#FF7733'
};
const HighlightDeal = _ref => {
  var _pill$label;
  let {
    namespace: namespaceFromProps,
    highlight_deal: pill,
    IconFactory
  } = _ref;
  const namespace = "".concat(namespaceFromProps, "__highlight-deal");
  return /*#__PURE__*/jsx(Fragment, {
    children: ((pill === null || pill === void 0 ? void 0 : pill.icon) || (pill === null || pill === void 0 || (_pill$label = pill.label) === null || _pill$label === void 0 ? void 0 : _pill$label.text)) && /*#__PURE__*/_jsx("div", {
      className: namespace
    }, void 0, /*#__PURE__*/_jsx(CustomPill, {
      namespace: namespaceFromProps,
      pill: pill,
      IconFactory: IconFactory,
      defaultStyles: defaultStyles$1
    }))
  });
};
HighlightDeal.defaultProps = {
  highlight_deal: {
    icon: null,
    label: {}
  }
};
const defaultStyles = {
  fontSize: '12px',
  fontWeight: '600',
  fontStyle: 'bold',
  color: '#333',
  background: '#FFFFFF'
};
const TopBrand = _ref => {
  var _pill$label;
  let {
    namespace: namespaceFromProps,
    top_brand: pill,
    IconFactory
  } = _ref;
  const namespace = "".concat(namespaceFromProps, "__top-brand");
  return /*#__PURE__*/jsx(Fragment, {
    children: ((pill === null || pill === void 0 ? void 0 : pill.icon) || (pill === null || pill === void 0 || (_pill$label = pill.label) === null || _pill$label === void 0 ? void 0 : _pill$label.text)) && /*#__PURE__*/_jsx("div", {
      className: namespace
    }, void 0, /*#__PURE__*/_jsx(CustomPill, {
      namespace: namespaceFromProps,
      pill: pill,
      IconFactory: IconFactory,
      defaultStyles: defaultStyles
    }))
  });
};
TopBrand.defaultProps = {
  top_brand: {
    icon: null,
    label: {}
  }
};
const Image = _ref => {
  let {
    namespace,
    image,
    lazyLoad,
    preload,
    fetchPriority,
    hasOverlay
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace, "__image-container")
  }, void 0, hasOverlay && /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace, "__image-overlay")
  }), /*#__PURE__*/_jsx(NordicImage, {
    src: image.src,
    srcSet: image.src2x ? "".concat(image.src, ", ").concat(image.src2x, " 2x") : undefined,
    className: "".concat(namespace, "__image"),
    width: image.size,
    height: image.size,
    alt: "",
    lazyload: lazyLoad && !preload ? 'on' : 'off',
    preload: preload,
    fetchPriority: fetchPriority
  }, "image"));
};
const Title = _ref => {
  var _span;
  let {
    namespace,
    meta,
    title,
    advertising,
    url,
    nofollow,
    onItemClick: onItemClickFromProps
  } = _ref;
  let urlForAds = url;
  let nofollowForAds = nofollow;
  if (advertising && advertising.click_url) {
    urlForAds = advertising.click_url;
    nofollowForAds = true;
  }
  const renderTitleElement = () => {
    // For webviews inside iframes (no navigation, postMessage to redirect)
    if (onItemClickFromProps) {
      const onItemClick = e => {
        onItemClickFromProps({
          event: e,
          target: urlForAds
        });
      };
      return /*#__PURE__*/_jsx("button", {
        "data-testid": "onclick-item-link",
        className: "".concat(namespace, "__link ").concat(namespace, "__link--button"),
        onClick: onItemClick
      }, void 0, _span || (_span = /*#__PURE__*/_jsx("span", {}, void 0, title)));
    }

    // For information cards (no navigation on click)
    if (!url) {
      return /*#__PURE__*/_jsx("span", {
        className: "".concat(namespace, "__link")
      }, void 0, title);
    }

    // For default scenarios
    return /*#__PURE__*/_jsx("a", {
      href: urlForAds,
      rel: nofollowForAds ? 'nofollow, sponsored' : null,
      className: "".concat(namespace, "__link")
    }, void 0, title);
  };
  return /*#__PURE__*/jsx(Fragment, {
    children: title && /*#__PURE__*/_jsx("p", {
      className: "".concat(namespace, "__title"),
      itemProp: meta ? 'name' : undefined
    }, "title", renderTitleElement())
  });
};
const _excluded$1 = ["id", "meta", "class_name", "className", "classNameFromMap", "classNameFromIndex", "cardLayout", "isListItem", "onBookmarkClick", "disableHover"];
function ownKeys$5(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$5(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$5(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$5(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
const namespace$1 = "".concat(namespaceRecommendations$1, "-card");
const CardBaseTitleLast = _ref => {
  let {
      id,
      meta,
      class_name,
      className,
      classNameFromMap,
      classNameFromIndex,
      cardLayout,
      isListItem,
      onBookmarkClick,
      disableHover
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded$1);
  const propsToFoward = _objectSpread$5(_objectSpread$5({}, rest), {}, {
    id,
    meta,
    namespace: namespace$1,
    onBookmarkClick
  });
  const WrapperElement = isListItem ? 'li' : 'div';
  return /*#__PURE__*/(
    // Main Wrapper for Card
    _jsx(WrapperElement, {
      className: classNames("".concat(namespace$1, " ").concat(namespace$1, "--").concat(cardLayout), class_name, className, classNameFromMap, classNameFromIndex, {
        ["".concat(namespaceRecommendations$1, "-disabled-hover")]: disableHover
      }),
      itemScope: meta ? true : undefined,
      itemType: meta ? 'http://schema.org/Product' : undefined
    }, id, /*#__PURE__*/jsx(Image, _objectSpread$5({}, propsToFoward)), /*#__PURE__*/_jsx("div", {
      className: classNames("".concat(namespace$1, "__content-and-hidden"), {
        ["".concat(namespace$1, "__content-and-hidden--with-bookmark")]: onBookmarkClick
      })
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: "".concat(namespace$1, "__content")
    }, "content", /*#__PURE__*/jsx(HighlightDeal, _objectSpread$5({}, propsToFoward)), /*#__PURE__*/jsx(TopBrand, _objectSpread$5({}, propsToFoward)), /*#__PURE__*/jsx(ChunkConditions, _objectSpread$5({}, propsToFoward)), /*#__PURE__*/jsx(ChunkAttributes, _objectSpread$5({}, propsToFoward)), /*#__PURE__*/jsx(Title, _objectSpread$5({}, propsToFoward)), /*#__PURE__*/jsx(ChunkOthers, _objectSpread$5({}, propsToFoward))), /*#__PURE__*/jsx(ChunkHidden, _objectSpread$5({}, propsToFoward))), /*#__PURE__*/jsx(BookmarkButton, _objectSpread$5({}, propsToFoward)))
  );
};
CardBaseTitleLast.defaultProps = {
  id: null,
  meta: false,
  cardLayout: '',
  className: '',
  classNameFromMap: '',
  classNameFromIndex: '',
  url: null,
  advertising: null,
  nofollow: false,
  title: null,
  attributes: null,
  installments_options: null,
  lazyLoad: true,
  preload: false,
  highlight_deal: null,
  top_brand: null,
  discount: null,
  installments: null,
  shipping: null,
  vertical_highlight: null,
  value_propositions: null,
  brand: null,
  actions: [],
  addToCartPublicEndpoint: null,
  csrfToken: null,
  track_info: null,
  category_id: null
};
function ownKeys$4(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$4(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$4(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$4(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
const CardVerticalTitleLast = props => /*#__PURE__*/jsx(CardBaseTitleLast, _objectSpread$4({
  cardLayout: "vertical"
}, props));
const _excluded = ["id", "meta", "class_name", "className", "classNameFromMap", "classNameFromIndex", "cardLayout", "isListItem", "onBookmarkClick", "disableHover"];
function ownKeys$3(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$3(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$3(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
const namespace = "".concat(namespaceRecommendations$1, "-card");
const CardBaseTitleFirst = _ref => {
  let {
      id,
      meta,
      class_name,
      className,
      classNameFromMap,
      classNameFromIndex,
      cardLayout,
      isListItem,
      onBookmarkClick,
      disableHover
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const propsToFoward = _objectSpread$3(_objectSpread$3({}, rest), {}, {
    id,
    meta,
    namespace,
    onBookmarkClick
  });
  const WrapperElement = isListItem ? 'li' : 'div';
  return /*#__PURE__*/(
    // Main Wrapper for Card
    _jsx(WrapperElement, {
      className: classNames("".concat(namespace, " ").concat(namespace, "--").concat(cardLayout), class_name, className, classNameFromMap, classNameFromIndex, {
        ["".concat(namespaceRecommendations$1, "-disabled-hover")]: disableHover
      }),
      itemScope: meta ? true : undefined,
      itemType: meta ? 'http://schema.org/Product' : undefined
    }, id, /*#__PURE__*/jsx(Image, _objectSpread$3({}, propsToFoward)), /*#__PURE__*/_jsx("div", {
      className: classNames("".concat(namespace, "__content-and-hidden"), {
        ["".concat(namespace, "__content-and-hidden--with-bookmark")]: onBookmarkClick
      })
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: "".concat(namespace, "__content")
    }, "content", /*#__PURE__*/jsx(HighlightDeal, _objectSpread$3({}, propsToFoward)), /*#__PURE__*/jsx(TopBrand, _objectSpread$3({}, propsToFoward)), /*#__PURE__*/jsx(Title, _objectSpread$3({}, propsToFoward)), /*#__PURE__*/jsx(ChunkConditions, _objectSpread$3({}, propsToFoward)), /*#__PURE__*/jsx(ChunkAttributes, _objectSpread$3({}, propsToFoward)), /*#__PURE__*/jsx(ChunkOthers, _objectSpread$3({}, propsToFoward))), /*#__PURE__*/jsx(ChunkHidden, _objectSpread$3({}, propsToFoward))), /*#__PURE__*/jsx(BookmarkButton, _objectSpread$3({}, propsToFoward)))
  );
};
CardBaseTitleFirst.defaultProps = {
  id: null,
  meta: false,
  cardLayout: '',
  className: '',
  classNameFromMap: '',
  classNameFromIndex: '',
  url: null,
  advertising: null,
  nofollow: false,
  title: null,
  attributes: null,
  lazyLoad: true,
  preload: false,
  highlight_deal: null,
  top_brand: null,
  discount: null,
  installments: null,
  shipping: null,
  vertical_highlight: null,
  value_propositions: null,
  brand: null,
  actions: [],
  addToCartPublicEndpoint: null,
  csrfToken: null,
  track_info: null,
  category_id: null
};
function ownKeys$2(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$2(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
const CardVerticalTitleFirst = props => /*#__PURE__*/jsx(CardBaseTitleFirst, _objectSpread$2({
  cardLayout: "vertical"
}, props));
function ownKeys$1(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$1(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
const CardHorizontalTitleLast = props => /*#__PURE__*/jsx(CardBaseTitleLast, _objectSpread$1({
  cardLayout: "horizontal"
}, props));
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
const CardHorizontalTitleFirst = props => /*#__PURE__*/jsx(CardBaseTitleFirst, _objectSpread({
  cardLayout: "horizontal"
}, props));
export { CardHorizontalTitleLast as RecommendationsCardHorizontal, CardHorizontalTitleFirst as RecommendationsCardHorizontalTitleFirst, CardVerticalTitleLast as RecommendationsCardVertical, CardVerticalTitleFirst as RecommendationsCardVerticalTitleFirst };
